module.exports = __webpack_public_path__ + "img/no-photo.d75bd89.svg";